module.exports = __webpack_public_path__ + "static/media/reporting.9d1e1365.svg";